import React from 'react';
import { Palette } from 'lucide-react';
import { useTheme } from '../ThemeContext';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isCyan = theme === 'cyan';

  return (
    <button
      onClick={toggleTheme}
      className="theme-toggle"
      title={isCyan ? 'Ganti ke tema klasik' : 'Ganti ke tema cyan'}
    >
      <Palette size={16} />
      <span>{isCyan ? 'Tema Cyan' : 'Tema Klasik'}</span>
    </button>
  );
}
